import { AppStatusIncident } from '@src/main/modules/app_status/domain/appStatusIncident.model';
import AppStatusDetailPreview from './AppStatusDetailPreview';

const AppStatusPossibleSolutionBody = ({
  possibleSolution,
  possibleSolutionImageUrl,
}: AppStatusIncident) => (
  <AppStatusDetailPreview
    value={possibleSolution}
    imageUrl={possibleSolutionImageUrl}
    imageAltTranslationKey="appStatus.columns.possibleSolution"
  />
);

export default AppStatusPossibleSolutionBody;
